<div class="continer-fluid">
  <h2
    style="
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
        Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      text-align: center;
    "
  >
    To-Do List
  </h2>
  <div class="container-fluid">
    <table class="table table-dark table-striped">
      <thead>
        <tr style="background-color: black; color: white; font-style: bold">
          <th class="td">ID</th>
          <th class="td">Title</th>
          <th class="td">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let todo of todos">
          <td class="td">{{ todo.id }}</td>
          <td class="td">{{ todo.title }}</td>
          <td class="td">
            <div *ngIf="!todo.completed" style="color: red;">Incompleted</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="d-flex justify-content-center">
  <div class="spinner-grow text-dark" role="status" *ngIf="loading">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
